import React from 'react';
import get from 'lodash/get';

import { FormatNumberOpts, useFormatNumber } from '../utils/format-number';

import { VariableId } from './types';
import { useSelector } from './utils';

export type FormattedValueOptions = {
  variableId: VariableId;
  opts?: FormatNumberOpts;
  fallbackValue?: number;
};

export const useFormattedValue = ({
  variableId,
  opts,
  fallbackValue,
}: FormattedValueOptions) => {
  const value = useSelector((s) => get(s.variables, variableId));
  const formatNumber = useFormatNumber();

  if (typeof value === 'undefined') {
    return fallbackValue !== undefined
      ? formatNumber(fallbackValue, opts)
      : null;
  }

  if (typeof value === 'number') {
    return formatNumber(value, opts);
  }

  return String(value);
};

export const FormattedValue = ({
  variableId,
  opts,
  fallbackValue,
}: FormattedValueOptions) => {
  const text = useFormattedValue({ variableId, opts, fallbackValue });
  return <>{text}</>;
};
